import { render, staticRenderFns } from "./SectionContents.vue?vue&type=template&id=16e6391c&scoped=true&lang=pug&"
import script from "./SectionContents.vue?vue&type=script&lang=js&"
export * from "./SectionContents.vue?vue&type=script&lang=js&"
import style0 from "./SectionContents.vue?vue&type=style&index=0&id=16e6391c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e6391c",
  null
  
)

/* custom blocks */
import block0 from "./SectionContents.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports